/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Partner_Billing_Board_Block_AgeInputs */



/**
* | output |
* | --- |
* | "{days} days" |
*
* @param {Partner_Billing_Board_Block_AgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_block_age = /** @type {((inputs: Partner_Billing_Board_Block_AgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Block_AgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.days} Tage`)
	return /** @type {LocalizedString} */ (`${i?.days} days`)
});